var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBucketCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4013_12797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4013_12797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.725 21C6.225 21 5.79167 20.8333 5.425 20.5C5.05833 20.1667 4.83333 19.7583 4.75 19.275L3 7H6V5C6 4.45 6.19583 3.97917 6.5875 3.5875C6.97917 3.19583 7.45 3 8 3H16C16.55 3 17.0208 3.19583 17.4125 3.5875C17.8042 3.97917 18 4.45 18 5V7H21L19.25 19.275C19.1667 19.7583 18.9375 20.1667 18.5625 20.5C18.1875 20.8333 17.75 21 17.25 21H6.725ZM5.3 9L6.725 19H17.275L18.7 9H5.3ZM10.95 17L15.9 12.05L14.475 10.65L10.95 14.175L9.525 12.75L8.1 14.175L10.95 17ZM8 7H16V5H8V7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucketCheck);
export default __webpack_public_path__ + "static/media/bucket_check.4e3db7e0f685903ced7ff7eb0623e888.svg";
export { ForwardRef as ReactComponent };